import React, { useState, useEffect, useRef } from 'react'

// next components
import Image from 'next/image'
import Link from 'next/link'

// custom functions
import { useViewport } from 'utils'
import useClickOutside from 'components/Menu/ClickOutsideMenu'

// images and icons
import Lottie from 'lottie-react'
import NotifyAlarmIcon from 'assets/lottery/notify-alarm.json'
import SolanaLogoMobileIcon from 'assets/icons/solana-logo-gray-14x12.svg?component'
import PlayVideoIcon from 'assets/icons/play-video.svg'
import PauseVideoIcon from 'assets/icons/pause-video.svg'
import EditionIcon from 'assets/icons/edition-icon.svg?component'
import ThreeDotIcon from 'assets/icons/three-dot-icon.svg?component'

// styles
import styles from './index.module.scss'
import ImageWithFoster from 'components/ImageWithFoster'
import { getDisplayUserName, getPriceValue } from 'utils/strings'
import { calculateAuctionTimeLeft } from 'utils/helpers'
import NftCardMenuPage from 'components/Menu/NftCardMenuPage'
import NftCardMenuModal from 'components/Modal/NftCardMenuModal'
import SocialShareModal from 'components/Menu/SocialShareModal'

const HomeEditionCard = props => {
  const { data, type = 'limit', onClick, connected } = props
  const viewport = useViewport()
  const [play, setPlay] = useState(false)
  const [timeLeft, setTimeLeft] = useState(null)
  const [showNftMenu, setShowNftMenu] = useState(false)
  const [openShareModal, setOpenShareModal] = useState(false)
  const [hover, setHover] = useState(false)
  const nftWidth = 600
  useEffect(() => {
    if (
      data.assetType?.includes('video') &&
      (viewport === 'xs' || viewport === 'sm' || viewport === 'md') &&
      data.coverImageUrl == null
    ) {
      let hidden_video: HTMLVideoElement = document.getElementById('hidden_video') as HTMLVideoElement
      hidden_video.currentTime = 3
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (data.endTime !== undefined && data.endTime !== null) {
      setTimeLeft(calculateAuctionTimeLeft(data.endTime))

      const timer = setInterval(() => {
        setTimeLeft(calculateAuctionTimeLeft(data.endTime))
      }, 1000)

      return () => clearTimeout(timer)
    }
  }, [data.endTime])

  const isExpired = () => {
    if (
      timeLeft &&
      timeLeft['days'] === '00' &&
      timeLeft['hours'] === '00' &&
      timeLeft['minutes'] === '00' &&
      timeLeft['seconds'] === '00'
    )
      return true
    return false
  }

  const menuRef = useRef(null)

  useClickOutside(menuRef, () => {
    if (viewport === 'lg' || viewport === 'xl' || viewport === '2xl') {
      setShowNftMenu(false)
    }
  })

  return (
    <div className={styles.layout} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <div className={styles.container}>
        <div className={styles.imageArea}>
          <div className={styles.imageContent}>
            {data.assetType?.includes('video') ? (
              viewport === 'xs' || viewport === 'sm' || viewport === 'md' ? (
                <div className="w-full relative flex justify-center items-center overflow-hidden">
                  <Link href={`${window.origin}/nft/${data.tokenId}`} passHref>
                    <a className="w-full h-full">
                      {play ? (
                        <div
                          className="w-full h-full absolute"
                          dangerouslySetInnerHTML={{
                            __html: `<video autoplay loop muted webkit-playsinline playsinline class="w-full h-full object-cover overflow-hidden">
              <source src=${data.assetUrl} type="video/mp4" /></video>`,
                          }}
                          onClick={() => onClick()}
                        />
                      ) : data.coverImageUrl != null && data.coverImageUrl !== '' ? (
                        <ImageWithFoster
                          src={data.coverImageUrl}
                          width={nftWidth}
                          onClick={onClick}
                          className="w-full h-full object-contain"
                        />
                      ) : (
                        <div
                          className="w-full h-full absolute"
                          dangerouslySetInnerHTML={{
                            __html: `<video id="hidden_video" muted webkit-playsinline playsinline class="w-full h-full object-contain overflow-hidden">
              <source src=${data.assetUrl} type="video/mp4" /></video>`,
                          }}
                          onClick={() => onClick()}
                        />
                      )}
                    </a>
                  </Link>
                  <div className={styles.playButton}>
                    <div className={`${play ? 'w-[18px]' : 'w-[22px]'} h-[18px] flex justify-end`}>
                      <Image
                        src={play ? PauseVideoIcon : PlayVideoIcon}
                        width={18}
                        height={18}
                        alt=""
                        onClick={() => setPlay(!play)}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <Link href={`${window.origin}/nft/${data.tokenId}`} passHref>
                  <a className="w-full h-full">
                    <div
                      className="w-full h-full"
                      dangerouslySetInnerHTML={{
                        __html: `<video autoplay loop muted webkit-playsinline playsinline class="w-full h-full object-cover overflow-hidden">
                <source src=${data.assetUrl} type="video/mp4" /></video>`,
                      }}
                      onClick={() => onClick()}
                    />
                  </a>
                </Link>
              )
            ) : data.assetType?.includes('audio') ? (
              <Link href={`${window.origin}/nft/${data.tokenId}`} passHref>
                <a className="w-full h-full">
                  <ImageWithFoster
                    src={data.coverImageUrl}
                    width={nftWidth}
                    className="w-full h-full object-contain"
                    onClick={() => onClick()}
                  />
                </a>
              </Link>
            ) : data.coverImageUrl ? (
              <Link href={`${window.origin}/nft/${data.tokenId}`} passHref>
                <a className="w-full h-full">
                  <ImageWithFoster
                    src={data.coverImageUrl}
                    width={nftWidth}
                    onClick={onClick}
                    originalSrc={data.fallBack}
                    className="w-full h-full object-contain"
                  />
                </a>
              </Link>
            ) : (
              <Link href={`${window.origin}/nft/${data.tokenId}`} passHref>
                <a className="w-full h-full">
                  <ImageWithFoster
                    src={data.assetUrl}
                    width={nftWidth}
                    onClick={onClick}
                    originalSrc={data.fallBack}
                    className="mw-full h-full object-contain"
                  />
                </a>
              </Link>
            )}
          </div>
        </div>

        <div className={`${styles.bidContainer}`}>
          <div className={styles.bidContentView}>
            <div className="w-full flex justify-between items-center">
              <div className="flex gap-[8px] items-center">
                <EditionIcon />
                <div className={styles.bidTime}>{type === 'limit' ? 'Limited Edition' : 'Open Edition'}</div>
              </div>
              {data.endTime !== null && data.startTime !== data.endTime && timeLeft && !isExpired() && (
                <div className={styles.timeSection}>
                  <div className="flex items-center">
                    {viewport === 'lg' ? (
                      'Ends in'
                    ) : (
                      <div className="flex">
                        Live&nbsp;
                        <div className="w-[15px]">
                          <Lottie animationData={NotifyAlarmIcon} loop={true} />
                        </div>
                        &nbsp;Ends in
                      </div>
                    )}
                    &nbsp;
                    {timeLeft['days'] !== '00' && (
                      <div className="flex">
                        {timeLeft['days']}
                        <div>d</div>
                      </div>
                    )}
                    &nbsp;
                    <div className="flex">
                      {timeLeft['hours']}
                      <div>h</div>
                    </div>
                    {Number(timeLeft['days']) == 0 && Number(timeLeft['hours']) == 0 && (
                      <div>
                        <div>
                          {timeLeft['minutes']}
                          <div>m</div>
                          &nbsp;
                        </div>
                      </div>
                    )}
                    {Number(timeLeft['days']) == 0 && Number(timeLeft['hours']) == 0 && (
                      <div>
                        <div>
                          {timeLeft['seconds']}
                          <div>s</div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div ref={menuRef} className="relative w-full flex flex-col mt-[5px]">
              <Link href={`/nft/${data.tokenId}`} passHref>
                <a className="w-fit">
                  <div className={styles.nftName}>{data?.nftName}</div>
                </a>
              </Link>

              {showNftMenu && (viewport === 'lg' || viewport === 'xl' || viewport === '2xl') && (
                <NftCardMenuPage
                  shareArtwork={() => {
                    setShowNftMenu(false)
                    setOpenShareModal(true)
                  }}
                  isOwn={false}
                  cardType={''}
                  hideArtwork={() => {}}
                  unhideArtwork={() => {}}
                  unSave={() => {}}
                />
              )}
              <div className="w-full flex items-center justify-between">
                <div className={styles.artistName}>
                  <Link href={`/${data.artistUsername}`} passHref>
                    <a className="w-fit">{getDisplayUserName(data.artistUsername)}</a>
                  </Link>
                </div>

                <div
                  className="w-[30px] h-[21px] flex justify-center items-center"
                  onClick={() => setShowNftMenu(!showNftMenu)}
                >
                  <div className={showNftMenu ? styles.ellipseContainer : styles.ellipseHover}>
                    <ThreeDotIcon alt="" />
                  </div>
                </div>
              </div>
            </div>

            <div>
              {isExpired() ? (
                <div className={`${styles.bidCountContainer} mt-[5px]`}>
                  <div className={styles.bidCount}>{'Edition Ended'}</div>
                </div>
              ) : (
                <div className="flex items-center mt-[5px]">
                  <div className={`h-full mr-[5px]`}>
                    <SolanaLogoMobileIcon alt="" />
                  </div>
                  <div className={styles.bidCount}>{getPriceValue(Number(data.price))}</div>
                  <div className="ml-2">
                    {type === 'limit' ? (
                      <div className={styles.editoinCount}>
                        {data.maxSupply - data.currentSupply + '/' + data.maxSupply + ' left'}
                      </div>
                    ) : (
                      <div className={styles.editoinCount}>{data.currentSupply + ' sold'}</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {openShareModal && (
        <SocialShareModal
          open={openShareModal}
          close={() => setOpenShareModal(false)}
          vote={true}
          message={'Check out this artist on Foster Marketplace @foster_protocol #fostermarketplace'}
          url={`/nft/${data.tokenId}`}
        />
      )}

      {showNftMenu && (viewport === 'xs' || viewport === 'sm' || viewport === 'md') && (
        <NftCardMenuModal
          open={showNftMenu}
          onClose={() => setShowNftMenu(false)}
          isOwn={false}
          shareArtwork={() => {
            setShowNftMenu(false)
            setOpenShareModal(true)
          }}
          hideArtwork={() => {}}
          unhideArtwork={() => {}}
          unSave={() => {}}
          cardType={''}
        />
      )}
    </div>
  )
}

export default HomeEditionCard
